module.exports = __webpack_public_path__ + "static/img/p3.9b64127.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/p3.png
// module id = F618
// module chunks = 0